export default {
  setLoading(state, value) {
    state.loading = value;
  },
  setIsPrePayment(state, value) {
    state.isPrePayment = value;
  }
};